"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.updateUserAttribute = exports.fetchUserAttributes = void 0;

var _ActionTypes = _interopRequireDefault(require("composer-lib/redux/ActionTypes"));

var _utils = require("composer-lib/lib/utils");

var _UserAttributesManager = _interopRequireDefault(require("composer-lib/data/UserAttributesManager"));

var userAttributesManager = new _UserAttributesManager.default();
var fetchUserAttributesPending = (0, _utils.createAction)(_ActionTypes.default.FETCH_USER_ATTRIBUTES_PENDING);
var fetchUserAttributesSucceeded = (0, _utils.createAction)(_ActionTypes.default.FETCH_USER_ATTRIBUTES_SUCCEEDED);
var fetchUserAttributesFailed = (0, _utils.createAction)(_ActionTypes.default.FETCH_USER_ATTRIBUTES_FAILED);

var fetchUserAttributes = function fetchUserAttributes(userId) {
  return function (dispatch) {
    dispatch(fetchUserAttributesPending());
    userAttributesManager.fetch(userId).then(function (resp) {
      return dispatch(fetchUserAttributesSucceeded(resp));
    }, function (resp) {
      return dispatch(fetchUserAttributesFailed(resp));
    });
  };
};

exports.fetchUserAttributes = fetchUserAttributes;
var updateUserAttributePending = (0, _utils.createAction)(_ActionTypes.default.UPDATE_USER_ATTRIBUTE_PENDING);
var updateUserAttributeSucceeded = (0, _utils.createAction)(_ActionTypes.default.UPDATE_USER_ATTRIBUTE_SUCCEEDED);
var updateUserAttributeFailed = (0, _utils.createAction)(_ActionTypes.default.UPDATE_USER_ATTRIBUTE_FAILED);

var updateUserAttribute = function updateUserAttribute(userId, key, value) {
  return function (dispatch) {
    dispatch(updateUserAttributePending({
      key: key,
      value: value
    }));
    userAttributesManager.updateAttribute(userId, key, value).then(function (resp) {
      return dispatch(updateUserAttributeSucceeded(resp));
    }, function (resp) {
      return dispatch(updateUserAttributeFailed(resp));
    });
  };
};

exports.updateUserAttribute = updateUserAttribute;